import React, { useEffect, useRef } from 'react';

const BUBBLES = [
  { left: '8%', size: 6, delay: 0, duration: 9 },
  { left: '18%', size: 4, delay: 2, duration: 11 },
  { left: '32%', size: 5, delay: 1, duration: 8 },
  { left: '48%', size: 3, delay: 3, duration: 12 },
  { left: '62%', size: 6, delay: 0.5, duration: 10 },
  { left: '74%', size: 4, delay: 4, duration: 9 },
  { left: '86%', size: 5, delay: 1.5, duration: 11 },
  { left: '94%', size: 3, delay: 2.5, duration: 8 },
];

const WaveLayer = ({ className, path, duration }) => (
  <div
    className={`login-wave-track ${className}`}
    style={{ '--wave-duration': `${duration}s` }}
  >
    <svg
      className='login-wave-svg'
      viewBox='0 0 1440 200'
      preserveAspectRatio='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d={path} />
    </svg>
    <svg
      className='login-wave-svg'
      viewBox='0 0 1440 200'
      preserveAspectRatio='none'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden='true'
    >
      <path d={path} />
    </svg>
  </div>
);

const LoginBackground = () => {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;

    const handleMove = e => {
      const x = (e.clientX / window.innerWidth - 0.5) * 2;
      const y = (e.clientY / window.innerHeight - 0.5) * 2;
      el.style.setProperty('--mouse-x', x.toFixed(3));
      el.style.setProperty('--mouse-y', y.toFixed(3));
    };

    window.addEventListener('mousemove', handleMove, { passive: true });
    return () => window.removeEventListener('mousemove', handleMove);
  }, []);

  return (
    <div className='login-bg-ocean' ref={ref} aria-hidden='true'>
      <div className='login-ocean-depth' />
      <div className='login-ocean-light' />

      <div className='login-ocean-waves'>
        <WaveLayer
          className='login-wave-layer--back'
          duration={22}
          path='M0,90 C240,150 480,30 720,90 C960,150 1200,30 1440,90 L1440,200 L0,200 Z'
        />
        <WaveLayer
          className='login-wave-layer--mid'
          duration={16}
          path='M0,110 C200,60 400,160 600,110 C800,60 1000,160 1200,110 C1320,80 1380,130 1440,110 L1440,200 L0,200 Z'
        />
        <WaveLayer
          className='login-wave-layer--front'
          duration={11}
          path='M0,130 C180,170 360,90 540,130 C720,170 900,90 1080,130 C1200,155 1320,105 1440,130 L1440,200 L0,200 Z'
        />
        <WaveLayer
          className='login-wave-layer--foam'
          duration={8}
          path='M0,155 C220,175 440,140 660,155 C880,170 1100,140 1320,155 C1380,160 1410,150 1440,155 L1440,200 L0,200 Z'
        />
      </div>

      <div className='login-ocean-bubbles'>
        {BUBBLES.map((b, i) => (
          <span
            key={i}
            className='login-ocean-bubble'
            style={{
              left: b.left,
              width: b.size,
              height: b.size,
              animationDelay: `${b.delay}s`,
              animationDuration: `${b.duration}s`,
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default LoginBackground;
